module.exports = __webpack_public_path__ + "img/bobobobo.75f53672.png";